'use strict';

var DateRangeChartViewport = function DateRangeChartViewport(ChartViewport, chartGroups, chartXAxis, chartSimpleBars) {
  var chartParams = require('./ParamsViewport');
  var chartScales = require('./ScalesViewport');
  var Chart = function Chart(container, formatters) {
    var groups = chartGroups('departureDateMoment').asViewport();
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withRepetition(1).withoutLine();
    ChartViewport.call(this, container, chartParams, chartScales, groups, m2Bars, m1Bars, xAxis);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
DateRangeChartViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsSimpleBars'];
module.exports = DateRangeChartViewport;